import { CustomerDto } from "../dto/ImportCoworkingCustomerRow";

export type ImportValidationResult = {
  fields: string[];
  messages: string[];
};

const REQUIRED_FIELDS: (keyof CustomerDto)[] = [
  "email",
  "phone",
  "productName",
  "startDate",
  "endDate",
];

const fieldsTranslations: Record<keyof CustomerDto, string> = {
  name: "nome",
  email: "email",
  phone: "telefone",
  affiliateId: "ID do afiliado",
  companyDocument: "documento da empresa",
  postalBoxNumber: "número da caixa postal",
  legalRepresentativeName: "nome do representante legal",
  legalRepresentativeDocument: "documento do representante legal",
  birthDate: "data de nascimento",
  address: "endereço",
  productName: "nome do produto",
  startDate: "data de início",
  endDate: "data de término",
};

const isValidIsoDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

  const [year, month, day] = value.split("-").map((part) => Number(part));
  const parsed = new Date(Date.UTC(year, month - 1, day));

  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() + 1 === month &&
    parsed.getUTCDate() === day
  );
};

const isValidPhone = (value: string): boolean => {
  const digits = value.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 11;
};

export const validateImportedCustomerRow = (
  row: CustomerDto,
): ImportValidationResult => {
  const fields: string[] = [];
  const messages: string[] = [];

  REQUIRED_FIELDS.forEach((field) => {
    const value = row[field];
    if (!value || (typeof value === "string" && !value.trim())) {
      fields.push(field);
      messages.push(`${fieldsTranslations[field]} é obrigatório`);
    }
  });

  if (row.phone && row.phone.trim() && !isValidPhone(row.phone)) {
    if (!fields.includes("phone")) {
      fields.push("phone");
    }
    messages.push("telefone deve conter entre 10 e 11 dígitos (apenas números)");
  }

  if (row.startDate && row.startDate.trim() && !isValidIsoDate(row.startDate)) {
    if (!fields.includes("startDate")) {
      fields.push("startDate");
    }
    messages.push("data de inicio deve ser uma data ISO válida (YYYY-MM-DD)");
  }

  if (row.endDate && row.endDate.trim() && !isValidIsoDate(row.endDate)) {
    if (!fields.includes("endDate")) {
      fields.push("endDate");
    }
    messages.push("data de término deve ser uma data ISO válida (YYYY-MM-DD)");
  }

  return { fields, messages };
};
